<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="row rsContainer" :class="{'rds': customFS }">
    <div id="reaction-stripe" class="row">
      <div class="aControls">
        <template v-if="true">
          <PlayPause
            v-if="player.video_type === 'live'"
            :player-state="playerState"
            :player-instance="playerInstance"
            theClass="playPause2"
          />

          <template v-if="customFS">
            <simple-mute theClass="muteBtn2" :player="player"></simple-mute>
            <simple-full-screen :player="player" />
          </template>
          <template v-else>
            <Mute theClass="muteBtn2" />
            <Fullscreen />
          </template>
        </template>
        <div class="takeASelfie" :class="{'disabled': !canTakePicture}"  @click="takePhoto()">
          <div class="takeASelfie__text">{{ $t('take_a_selfie') }}</div>
          <div class="takeASelfie__camera">
            <Camera />
            <transition
              enterActiveClass="animated fadeInDown"
              leaveActiveClass="animated fadeOutUp"
            >
              <div class="PopOver" v-if="showPopover">
                <div class="PopOver__content">
                  <img :src="showPopover" alt="Selfie cover">
                </div>
                <div class="PopOver__arrow"></div>
              </div>
            </transition>

          </div>
        </div>
        <!--<img src="images/photo.svg" alt="" onclick="selfie_step1_get_groupphoto_id()">-->
        <!--
        <div style="display: none; margin-top: 45px;"
             class="selfie-box inline-block cursor-pointer"
             onclick="selfie_step1_get_groupphoto_id()">
          <div class="selfie-text text-center position: relative">
            <div style="height: 40px; width: 100%; position: absolute; overflow: hidden"
                 class="d-none d-xl-block">
              {{ $t('Scatta un selfie e appari sul palco') }}
            </div>
            <div class="photo float-right">
              <img class="photo-icon" src="images/photo.svg" alt="">
            </div>
          </div>
        </div>
        -->
      </div>
      <div class="aButtons">
        <div id="alive-buttons"></div>
      </div>
      <div class="aMessage">
        <div id="message" style="display: none">
          <div class="text-message">
            <input v-model="aliveText" @input="$emit('activity')" id="alive-text" @keyup="onEnter" :placeholder="$t('message_for_alive')">
            <Send onclick="message($( '#alive-text').val())" />
            <!--
            <button class="btn cursor-pointer invia" onclick="($( '#alive-text').val())message">
              {{ $t('submit') }}
            </button>
            -->
          </div>
        </div>
      </div>
    </div>
    <div id="preview">
      <img id="preview_image" src="">
      <br>
      <div id="social-sharing" class="text-center"></div>
    </div>
    <div id="log"></div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';
import SimpleFullScreen from '@/components/glyphs/SimpleFullScreen.vue';
import SimpleMute from '@/components/glyphs/SimpleMute.vue';
import Mute from './glyphs/Mute.vue';
import PlayPause from './glyphs/PlayPause.vue';
import Camera from './glyphs/Camera.vue';
import Send from './glyphs/Send.vue';
import Fullscreen from './glyphs/Fullscreen.vue';

// const { detect } = require('detect-browser');

export default {
  props: [
    'player',
    'playerState',
    'playerInstance',
    'customFS',
    'bottom',
  ],
  name: 'ReactionStripe',
  mounted() {
    // onst browser = detect();
    // const token = this.getToken;
    /*
    this.reactionStripeConfig = {
      ADS_URL: this.conf[this.env].ADS_URL,
      appid: this.conf[this.env].appid,
      service: this.conf[this.env].service,
      host: this.conf[this.env].host,
      BASE_GROUP_PHOTO_URL: this.conf[this.env].BASE_GROUP_PHOTO_URL,
      BASE_SHARE_URL: `${this.conf[this.env].BASE_SHARE_URL + this.conf[this.env].appid}/${this.$t('lang')}?id=`,
      TWITTER_TEXT: encodeURI(this.$t('TWITTER_TEXT')),
      browser,
    };
    */
    // window.initBar();
    // window.start(token, this.reactionStripeConfig);
  },
  data() {
    return {
      reactionStripeConfig: {},
      aliveText: '',
      processing: false,
    };
  },
  methods: {
    ...mapMutations(['setCanTakePicture']),
    ...mapActions(['setShowPopover']),
    takePhoto() {
      if (this.processing) return;
      this.processing = true;
      this.setShowPopover(false);
      setTimeout(() => {
        this.processing = false;
      }, 4000);
      window.selfie_step1_get_groupphoto_id();
    },
    onEnter(e) {
      if (e.keyCode === 13) {
        window.message(this.aliveText);
      }
    },
  },
  computed: {
    ...mapState(['conf', 'env', 'canTakePicture', 'showPopover', 'showCamera', 'showPreview']),
    ...mapGetters(['getToken']),
  },
  components: {
    SimpleMute,
    SimpleFullScreen,
    PlayPause,
    Mute,
    Camera,
    Send,
    Fullscreen,
  },
};
</script>

<style>
.modal {
  padding: 15px;
}
.blocker {
  z-index: 1059;
}
.webcamVideo, #preview_image {
  border-radius: 3px;
}

@media screen and (max-width: 950px) {
  .rsContainer {
    width: 100%;
    position: fixed;
    bottom: 80px;
  }
}

.rsContainer {
  width: 100%;
  position: fixed;
  bottom: 20px;
  z-index: 1000;
}
.rsContainer.rds {
  bottom: 110px;
}

#alive-text {
}

.aButtons {
  display: flex;
  align-items: center;
  flex: auto;
}
@media screen and (max-width: 500px) {
  .aButtons {
    margin-bottom: 10px;
  }
}
.aControls {
  display: flex;
  align-items: center;
  padding-left: 20px;
}
@media screen and (max-width: 500px) {
  .aControls {
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
    padding-left: 0px;
    margin-bottom: 10px;
  }
  #reaction-stripe.open {
    height: auto;
  }
}

.aMessage {
  display: flex;
  align-items: center;
  margin-right: 20px;
}
@media screen and (max-width: 500px) {
  .aMessage {
    margin-bottom: 5px;
  }
}
@media screen and (max-width: 750px) {
  .aMessage {
    flex-basis: 100%;
    margin-left: 20px;
    display: flex;
    justify-content: center;
  }
}

.sButton {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 18px;
  margin: 0 10px;
}
#message {
  flex: 1;
}
.takeASelfie {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.takeASelfie.disabled {
  opacity: 0.3;
}
.takeASelfie__text {
  display: none;
}
.takeASelfie__camera {
  position: relative;
}
@media screen and (min-width: 1200px) {
  .takeASelfie__camera {
    left: -20px;
  }
  .takeASelfie__text {
    display: flex;
    background-color: rgba(113, 113, 113, 0.7);
    align-items: center;
    border-radius: 10px;
    padding: 0 30px 0 10px;
    height: 40px;
  }
}
#reaction-stripe {
  overflow: visible;
}
</style>
